export default __webpack_public_path__ + "static/media/Skirmisher's Dirk.04a6542d.jpg";